@if(mode==="edit"){
@if(source !== 'enrollment'){
<div class="ppl-mt8">
  @for(header of extractValues('header'); track $index){
  <h2>{{header}}</h2>
  }
  @for(text of extractValues('text'); track $index){
  <p class="ppl-description">{{text}}</p>
  }
</div>
}
<div [ngClass]="{'ppl-mt24': source !== 'enrollment'}">
  <nz-card nz-col class="ppl-step-main" [nzBordered]="false">
    <form id="enrollmentInfoForm" nz-form [formGroup]="infoForm" class="ppl-p0"
      appAutoFocusFirstInput>
      @if(flow === 'employer'){
      <nz-row>
        @if(isAttrAvailable('taskManager')){
        <div nz-col [nzSpan]="8" [nzSm]="10" [nzXs]="10">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="taskManager"
              class="ppl-form-label">{{getAttributes('taskManager').label}}
              @if(getAttributes('taskManager').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control" nz-tooltip
              nzTooltipTitle="{{getAttributes('taskManager').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{ 'error': validationErrors['taskManager'] }">
                <ppl-dropdown-select
                  formControlName="taskManager"
                  id="taskManager"
                  [options]="taskManagerOptions"
                  [optionLabel]="'lkpValueName'"
                  [optionValue]="'lkpValueCode'"
                  placeholder="{{getAttributes('taskManager').placeholder}}"
                  aria-required="true"
                  aria-describedby="taskManagerError"
                  [attr.aria-invalid]="validationErrors['taskManager'] ? 'true' : 'false'"
                  (selectionChange)="onTrackingManagerChange($event)">
                </ppl-dropdown-select>
              </div>
              @if (validationErrors['taskManager']) {
              <span id="taskManagerError" class="pl-1 error-message"
                role="alert">
                {{ validationErrors['taskManager'] }}
              </span>
              }

            </nz-form-control>
          </nz-form-item>
        </div>
        }
      </nz-row>
      }

      @if((flow !== 'employer' && !isAttrAvailable('taskManager')) ||
      (flow === 'employer' && isAttrAvailable('taskManager') &&
      infoForm.get('taskManager')?.value !== null)) {
      @if(flow === 'employer' && isAttrAvailable('taskManager')){
      <nz-divider class="divider"></nz-divider>
      }
      <nz-row>
        @if(isAttrAvailable('legalName')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="legalName"
              class="ppl-form-label">{{getAttributes('legalName').label}}
              @if(getAttributes('legalName').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('legalName')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <input nz-input formControlName="legalName" id="legalName"
                  placeholder="{{getAttributes('legalName').placeholder}}"
                  [ngClass]="{'error': validationErrors['legalName'] }"
                  [readonly]="formReadonly" />
              </div>
              @if (validationErrors['legalName']) {
              <span
                class="pl-1 error-message">{{validationErrors['legalName']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('businessName')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="businessName"
              class="ppl-form-label">{{getAttributes('businessName').label}}
              @if(getAttributes('businessName').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('businessName')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <input nz-input formControlName="businessName" id="businessName"
                  placeholder="{{getAttributes('businessName').placeholder}}"
                  [ngClass]="{'error': validationErrors['businessName'] }"
                  [readonly]="formReadonly" />
              </div>
              @if (validationErrors['businessName']) {
              <span
                class="pl-1 error-message">{{validationErrors['businessName']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }

        @if(isAttrAvailable('doingBusinessAs')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="doingBusiness"
              class="ppl-form-label">{{getAttributes('doingBusinessAs').label}}
              @if(getAttributes('doingBusinessAs').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('doingBusinessAs')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <input nz-input formControlName="dbaName" id="doingBusiness"
                  placeholder="{{getAttributes('doingBusinessAs').placeholder}}"
                  [ngClass]="{'error': validationErrors['doingBusinessAs'] }"
                  [readonly]="formReadonly" />
              </div>
              @if (validationErrors['doingBusinessAs']) {
              <span
                class="pl-1 error-message">{{validationErrors['doingBusinessAs']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }

        @if(isAttrAvailable('fname')){
        <nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="fname"
              class="ppl-form-label">{{getAttributes('fname').label}}
              @if(getAttributes('fname').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('fname')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <input nz-input formControlName="fname" id="fname"
                  placeholder="{{getAttributes('fname').placeholder}}"
                  [ngClass]="{'error': validationErrors['fname'] }"
                  [readonly]="formReadonly" />
              </div>
              @if (validationErrors['fname']) {
              <span
                class="pl-1 error-message">{{validationErrors['fname']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        }

        @if(isAttrAvailable('mname')){
        <nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="mname"
              class="ppl-form-label">{{getAttributes('mname').label}}
              @if(getAttributes('mname').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('mname')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <input nz-input formControlName="mname" id="mname"
                  placeholder="{{getAttributes('mname').placeholder}}"
                  [ngClass]="{'error': validationErrors['mname'] }"
                  [readonly]="formReadonly" />
              </div>
              @if (validationErrors['mname']) {
              <span
                class="pl-1 error-message">{{validationErrors['mname']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        }

        @if(isAttrAvailable('lname')){
        <nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="lname"
              class="ppl-form-label">{{getAttributes('lname').label}}
              @if(getAttributes('lname').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('lname')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <input nz-input formControlName="lname" id="lname"
                  placeholder="{{getAttributes('lname').placeholder}}"
                  [ngClass]="{'error': validationErrors['lname'] }"
                  [readonly]="formReadonly" />
              </div>
              @if (validationErrors['lname']) {
              <span
                class="pl-1 error-message">{{validationErrors['lname']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        }

        @if(isAttrAvailable('maiden_name')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="maiden_name"
              class="ppl-form-label">{{getAttributes('maiden_name').label}}
              @if(getAttributes('maiden_name').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('maiden_name')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <input nz-input formControlName="maiden_name" id="maiden_name"
                  placeholder="{{getAttributes('maiden_name').placeholder}}"
                  [ngClass]="{'error': validationErrors['maiden_name'] }"
                  [readonly]="formReadonly" />
              </div>
              @if (validationErrors['maiden_name']) {
              <span
                class="pl-1 error-message">{{validationErrors['maiden_name']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('dob')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="dob"
              class="ppl-form-label">{{getAttributes('dob').label}}
              @if(getAttributes('dob').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('dob')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <!-- <nz-date-picker formControlName="dob" id="dob" [nzFormat]="'MM/dd/yyyy'"
                    [nzPlaceHolder]="getAttributes('dob').placeholder" [nzDisabledDate]="disabledDate"
                    [ngClass]="{'error': validationErrors['dob'] }" [nzDisabled]="formReadonly" ></nz-date-picker> -->
                <ppl-date-picker formControlName="dob" id="dob"
                  [showIcon]="true"
                  [placeholder]="getAttributes('dob').placeholder"
                  dateFormat="mm/dd/yy" [readonlyInput]="false"
                  [monthNavigator]="true" [yearNavigator]="true"
                  [yearRange]="'1900:2050'" [iconDisplay]="'input'"
                  inputId="icondisplay"
                  [panelStyleClass]="'custom-calendar-panel date-picker-popup'"
                  [maxDate]="yesterday"
                  [styleClass]="validationErrors['dob'] ? 'error' : ''"
                  [disableControl]="formReadonly">
                </ppl-date-picker>
              </div>
              @if (validationErrors['dob']) {
              <span
                class="pl-1 error-message">{{validationErrors['dob']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('conservatorship')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="conservatorship"
              class="ppl-form-label">{{getAttributes('conservatorship').label}}
              @if(getAttributes('conservatorship').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('conservatorship')?.tooltip || ''"
                nzTooltipPlacement="topRight"
                [ngClass]="{'error': validationErrors['conservatorship'] }">
                <ppl-dropdown-select
                  formControlName="conservatorship"
                  id="conservatorship"
                  [options]="conservatorshipTypes"
                  [optionLabel]="'lkpValueName'"
                  [optionValue]="'lkpValueCode'"
                  [placeholder]="getAttributes('conservatorship').placeholder"
                  [disabled]="formReadonly">
                </ppl-dropdown-select>
              </div>
              @if (validationErrors['conservatorship']) {
              <span class="pl-1 error-message">{{validationErrors['conservatorship']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }

        @if(isAttrAvailable('gender')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="gender"
              class="ppl-form-label">{{getAttributes('gender').label}}
              @if(getAttributes('gender').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div
                [ngClass]="{ 'error': validationErrors['gender'] }"
                nz-tooltip
                [nzTooltipTitle]="getAttributes('gender')?.tooltip || ''"
                nzTooltipPlacement="topRight">

                <ppl-dropdown-select
                  formControlName="gender"
                  id="gender"
                  [options]="gender"
                  [optionLabel]="'lkpValueName'"
                  [optionValue]="'lkpValueCode'"
                  [placeholder]="getAttributes('gender')?.label"
                  [disabled]="formReadonly"
                  aria-required="true"
                  aria-describedby="genderError"
                  [attr.aria-label]="getAttributes('gender')?.label"
                  [attr.aria-invalid]="validationErrors['gender'] ? 'true' : 'false'">
                </ppl-dropdown-select>
              </div>

              @if (validationErrors['gender']) {
              <span id="genderError" class="pl-1 error-message" role="alert">
                {{ validationErrors['gender'] }}
              </span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('isProvidingServices')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="gender"
              class="ppl-form-label">{{getAttributes('isProvidingServices').label}}
              @if(getAttributes('isProvidingServices').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('isProvidingServices')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <nz-radio-group formControlName="isProvidingServices"
                  class="ppl-radio-group" id="isProvidingServices"
                  [ngClass]="{'error': validationErrors['isProvidingServices'] }">
                  @for(opt of radioOptions; track $index){
                  <label nz-radio-button
                    [nzValue]="opt.value">{{opt.label}}</label>
                  }
                </nz-radio-group>
              </div>
              @if (validationErrors['isProvidingServices']) {
              <span
                class="pl-1 error-message">{{validationErrors['isProvidingServices']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('SSN')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="SSN"
              class="ppl-form-label">{{getAttributes('SSN').label}}
              @if(isSsnMandatory()){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('SSN')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <nz-input-group [nzSuffix]="ssnSuffixTemplate"
                  [ngClass]="{'error': validationErrors['SSN'] }">
                  <input class="ssn-input" nz-input
                    [type]="ssnVisible ? 'text' : 'password'"
                    formControlName="SSN" id="SSN" autocomplete="off"
                    (input)="limitDigits($event)"
                    placeholder="{{getAttributes('SSN').placeholder}}"
                    [readonly]="formReadonly" />
                </nz-input-group>
              </div>
              <ng-template #ssnSuffixTemplate>
                <span nz-icon [nzType]="ssnVisible ? 'eye' : 'eye-invisible'"
                  (click)="ssnVisible = !ssnVisible"></span>
              </ng-template>
              @if (validationErrors['SSN']) {
              <span
                class="pl-1 error-message">{{validationErrors['SSN']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('ITIN')){
          <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="ITIN"
              class="ppl-form-label">{{getAttributes('ITIN').label}}
              @if(isItinMandatory()){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('ITIN')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <nz-input-group [nzSuffix]="itinSuffixTemplate"
                  [ngClass]="{'error': validationErrors['ITIN'] }">
                  <input class="ssn-input" nz-input
                    [type]="itinVisible ? 'text' : 'password'"
                    formControlName="ITIN" id="ITIN" autocomplete="off"
                    (input)="limitItinDigits($event)"
                    placeholder="{{getAttributes('ITIN').placeholder}}"
                    [readonly]="formReadonly" />
                </nz-input-group>
              </div>
              <ng-template #itinSuffixTemplate>
                <span nz-icon [nzType]="itinVisible ? 'eye' : 'eye-invisible'"
                  (click)="itinVisible = !itinVisible"></span>
              </ng-template>
              @if (validationErrors['ITIN']) {
              <span
                class="pl-1 error-message">{{validationErrors['ITIN']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('TIN')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="TIN"
              class="ppl-form-label">{{getAttributes('TIN').label}}
              @if(getAttributes('TIN').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('TIN')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <nz-input-group [nzSuffix]="tinSuffixTemplate"
                  [ngClass]="{'error': validationErrors['TIN'] }">
                  <input nz-input [type]="tinVisible ? 'text' : 'password'"
                    formControlName="TIN" id="TIN" autocomplete="off"
                    (input)="limitTinDigits($event)"
                    placeholder="{{getAttributes('TIN').placeholder}}"
                    [readonly]="formReadonly" />
                </nz-input-group>
              </div>
              <ng-template #tinSuffixTemplate>
                <span nz-icon [nzType]="tinVisible ? 'eye' : 'eye-invisible'"
                  (click)="tinVisible = !tinVisible"></span>
              </ng-template>
              @if (validationErrors['TIN']) {
              <span
                class="pl-1 error-message">{{validationErrors['TIN']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('CIN')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="CIN"
              class="ppl-form-label">{{getAttributes('CIN').label}}
              @if(getAttributes('CIN').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('CIN')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <input nz-input id="CIN" formControlName="CIN"
                  placeholder="{{getAttributes('CIN').placeholder}}"
                  [ngClass]="{'error': validationErrors['CIN'] }"
                  [readonly]="formReadonly" />
              </div>
              @if (validationErrors['CIN']) {
              <span
                class="pl-1 error-message">{{validationErrors['CIN']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('EIN')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="EIN"
              class="ppl-form-label">{{getAttributes('EIN').label}}
              @if(isEinMandatory()){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('EIN')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <input nz-input formControlName="EIN" id="EIN"
                  placeholder="{{getAttributes('EIN').placeholder}}"
                  (input)="limitDigits($event, 'EIN')"
                  [ngClass]="{'error': validationErrors['EIN'] }" />
              </div>
              @if (validationErrors['EIN']) {
              <span
                class="pl-1 error-message">{{validationErrors['EIN']}}</span>
              }

            </nz-form-control>
          </nz-form-item>

        </div>
        @if(flow === 'employer'){
        <div nz-col [nzSm]="18" [nzXs]="24" class="notes">
          <strong>Notes:</strong>
          <p>
            1. If EIN is lost/misplaced, then obtain your existing EIN using
            "<a>How to ask the IRS
              for a
              147c letter</a>".
          </p>
          <p>
            2. If EIN doesn't exist, PPL will obtain an EIN on your behalf after
            completion and
            submission
            of registration paperwork.
          </p>
        </div>
        }
        }
        @if(isAttrAvailable('waiver')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="waiver"
              class="ppl-form-label">{{getAttributes('waiver').label}}
              @if(getAttributes('waiver').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control" nz-tooltip
              nzTooltipTitle="{{getAttributes('waiver').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{ 'error': validationErrors['waiver'] }">
                <ppl-dropdown-select
                  formControlName="waiver"
                  id="waiver"
                  [options]="waiver"
                  [optionLabel]="'lkpValueName'"
                  [optionValue]="'lkpValueCode'"
                  placeholder="Select Service Administration"
                  [disabled]="formReadonly"
                  aria-required="true"
                  aria-describedby="waiverError"
                  aria-label="Select Service Administration"
                  [attr.aria-invalid]="validationErrors['waiver'] ? 'true' : 'false'">
                </ppl-dropdown-select>

                @if (validationErrors['waiver']) {
                <span id="waiverError" class="pl-1 error-message" role="alert">
                  {{ validationErrors['waiver'] }}
                </span>
                }
              </div>

            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('mcoOrgName')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="mcoOrgName"
              class="ppl-form-label">{{getAttributes('mcoOrgName').label}}
              @if(getAttributes('mcoOrgName').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control" nz-tooltip
              nzTooltipTitle="{{getAttributes('mcoOrgName').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{ 'error': validationErrors['mcoOrgName'] }">
                <ppl-dropdown-select
                  formControlName="mcoOrgName"
                  id="mcoOrgName"
                  [options]="mcoEntries"
                  [optionLabel]="'orgName'"
                  [optionValue]="'orgName'"
                  placeholder="Select MCO"
                  [disabled]="formReadonly"
                  aria-required="true"
                  aria-describedby="mcoOrgNameError"
                  aria-label="Select MCO"
                  [attr.aria-invalid]="validationErrors['mcoOrgName'] ? 'true' : 'false'">
                </ppl-dropdown-select>

                @if (validationErrors['mcoOrgName']) {
                <span id="mcoOrgNameError" class="pl-1 error-message"
                  role="alert">
                  {{ validationErrors['mcoOrgName'] }}
                </span>
                }
              </div>

            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('fiOrgName')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="fiOrgName"
              class="ppl-form-label">{{getAttributes('fiOrgName').label}}
              @if(getAttributes('fiOrgName').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control" nz-tooltip
              nzTooltipTitle="{{getAttributes('fiOrgName').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{ 'error': validationErrors['fiOrgName'] }">
                <ppl-dropdown-select
                  formControlName="fiOrgName"
                  id="fiOrgName"
                  [options]="fiEntries"
                  [optionLabel]="'orgName'"
                  [optionValue]="'orgName'"
                  placeholder="Select FI"
                  [disabled]="formReadonly"
                  aria-required="true"
                  aria-describedby="fiOrgNameError"
                  aria-label="Select FI"
                  [attr.aria-invalid]="validationErrors['fiOrgName'] ? 'true' : 'false'">
                </ppl-dropdown-select>

                @if (validationErrors['fiOrgName']) {
                <span id="fiOrgNameError" class="pl-1 error-message"
                  role="alert">
                  {{ validationErrors['fiOrgName'] }}
                </span>
                }
              </div>

            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('relationToParticipant')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="relationToParticipant"
              class="ppl-form-label">{{getAttributes('relationToParticipant').label}}
              @if(getAttributes('relationToParticipant').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control" nz-tooltip
              nzTooltipTitle="{{getAttributes('relationToParticipant').tooltip}}"
              nzTooltipPlacement="topRight">
              <div
                [ngClass]="{ 'error': validationErrors['relationToParticipant'] }">
                <ppl-dropdown-select
                  formControlName="relationToParticipant"
                  id="relationToParticipant"
                  [options]="relationshipOptions"
                  [optionLabel]="'lkpValueName'"
                  [optionValue]="'lkpValueCode'"
                  placeholder="Select relation to Participant"
                  [disabled]="formReadonly"
                  aria-required="true"
                  aria-describedby="relationToParticipantError"
                  aria-label="Select relation to Participant"
                  [attr.aria-invalid]="validationErrors['relationToParticipant'] ? 'true' : 'false'">
                </ppl-dropdown-select>
              </div>
              @if (validationErrors['relationToParticipant']) {
              <span id="relationToParticipantError" class="pl-1 error-message"
                role="alert">
                {{ validationErrors['relationToParticipant'] }}
              </span>
              }

            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('showOnDirectory')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="showOnDirectory"
              class="ppl-form-label">{{getAttributes('showOnDirectory').label}}
              @if(getAttributes('showOnDirectory').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('showOnDirectory')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <nz-radio-group
                  [ngClass]="{'error': validationErrors['showOnDirectory'] }"
                  formControlName="showOnDirectory" class="ppl-radio-group"
                  id="showOnDirectory">
                  @for(opt of radioOptions; track $index){
                  <label nz-radio-button
                    [nzValue]="opt.value">{{opt.label}}</label>
                  }
                </nz-radio-group>
              </div>
              @if (validationErrors['showOnDirectory']) {
              <span
                class="pl-1 error-message">{{validationErrors['showOnDirectory']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('NPI')){
        <div nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" nzFor="NPI"
              class="ppl-form-label">{{getAttributes('NPI').label}}
              @if(getAttributes('NPI').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('NPI')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <input nz-input formControlName="NPI" id="NPI"
                  placeholder="{{getAttributes('NPI').placeholder}}"
                  [ngClass]="{'error': validationErrors['NPI'] }"
                  [readonly]="formReadonly" />
              </div>
              @if (validationErrors['NPI']) {
              <span
                class="pl-1 error-message">{{validationErrors['NPI']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('additionalDemographics')){
        <div nz-col [nzSm]="24" [nzXs]="24">
          <!-- <nz-divider class="divider"></nz-divider> -->
          <nz-form-label [nzSpan]="24" nzFor="additionalDemographics"
            class="ppl-form-label"
            style="margin:8px 0 24px 0;">{{getAttributes('additionalDemographics').label}}
            @if(getAttributes('additionalDemographics').mandatory === 'Y'){
            <span>*</span>
            }
          </nz-form-label>
          <nz-row>
            @if(isAttrAvailable('race')){
            <div nz-col [nzSm]="6" [nzXs]="24">
              <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
                <nz-form-label [nzSpan]="24" nzFor="race"
                  class="ppl-form-label">{{getAttributes('race').label}}
                  @if(getAttributes('race').mandatory === 'Y'){
                  <span>*</span>
                  }
                </nz-form-label>
                <nz-form-control [nzSpan]="24" class="ppl-form-control"
                  nz-tooltip
                  nzTooltipTitle="{{getAttributes('race').tooltip}}"
                  nzTooltipPlacement="topRight">
                  <div [ngClass]="{ 'error': validationErrors['race'] }">
                    <ppl-dropdown-select
                      formControlName="race"
                      id="race"
                      [options]="raceOptions"
                      [optionLabel]="'lkpValueName'"
                      [optionValue]="'lkpValueCode'"
                      placeholder="Select Race"
                      [disabled]="formReadonly"
                      aria-required="true"
                      aria-describedby="raceError"
                      aria-label="Select Race"
                      [attr.aria-invalid]="validationErrors['race'] ? 'true' : 'false'">
                    </ppl-dropdown-select>

                    @if (validationErrors['race']) {
                    <span id="raceError" class="pl-1 error-message"
                      role="alert">
                      {{ validationErrors['race'] }}
                    </span>
                    }
                  </div>

                </nz-form-control>
              </nz-form-item>
            </div>
            }
            @if(isAttrAvailable('height')){
            <div nz-col [nzSm]="6" [nzXs]="24">
              <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
                <nz-form-label [nzSpan]="24" nzFor="height"
                  class="ppl-form-label">{{getAttributes('height').label}}
                  @if(getAttributes('height').mandatory === 'Y'){
                  <span>*</span>
                  }
                </nz-form-label>
                <nz-form-control [nzSpan]="24" class="ppl-form-control">
                  <div nz-tooltip
                    [nzTooltipTitle]="getAttributes('height')?.tooltip || ''"
                    nzTooltipPlacement="topRight"
                    class="height-input-container ppl-form-control">
                    <nz-row>
                      <nz-col [nzSm]="12" [nzXs]="24">
                        <input nz-input formControlName="heightFeet"
                          id="heightFeet" placeholder="Feet"
                          [ngClass]="{'error': validationErrors['heightFeet']}"
                          [readonly]="formReadonly" />
                        <!-- <span>Feet</span> -->
                      </nz-col>
                      <nz-col [nzSm]="12" [nzXs]="24">
                        <input nz-input formControlName="heightInches"
                          id="heightInches" placeholder="Inches"
                          [ngClass]="{'error': validationErrors['heightInches']}" />
                        <!-- <span>Inches</span> -->
                      </nz-col>
                    </nz-row>
                  </div>
                </nz-form-control>
              </nz-form-item>
            </div>
            }
            @if(isAttrAvailable('weight')){
            <div nz-col [nzSm]="6" [nzXs]="24">
              <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
                <nz-form-label [nzSpan]="24" nzFor="weight"
                  class="ppl-form-label">
                  {{getAttributes('weight').label}}
                  @if(getAttributes('weight').mandatory === 'Y'){
                  <span>*</span>
                  }
                </nz-form-label>
                <nz-form-control [nzSpan]="24" class="ppl-form-control">
                  <div nz-tooltip
                    [nzTooltipTitle]="getAttributes('weight')?.tooltip || ''"
                    nzTooltipPlacement="topRight"
                    class="weight-input-container ppl-form-control">
                    <input nz-input formControlName="weight" id="weight"
                      placeholder="{{getAttributes('weight').placeholder}}"
                      [ngClass]="{'error': validationErrors['weight']}"
                      [readonly]="formReadonly" />
                    <!-- <span class="unit-label">Pounds</span> -->
                  </div>
                </nz-form-control>
              </nz-form-item>
            </div>
            }
            @if(isAttrAvailable('eyeColor')){
            <div nz-col [nzSm]="6" [nzXs]="24">
              <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
                <nz-form-label [nzSpan]="24" nzFor="eyeColor"
                  class="ppl-form-label">{{getAttributes('eyeColor').label}}
                  @if(getAttributes('eyeColor').mandatory === 'Y'){
                  <span>*</span>
                  }
                </nz-form-label>
                <nz-form-control [nzSpan]="24" class="ppl-form-control"
                  nz-tooltip
                  nzTooltipTitle="{{getAttributes('eyeColor').tooltip}}"
                  nzTooltipPlacement="topRight">
                  <div [ngClass]="{ 'error': validationErrors['eyeColor'] }">
                    <ppl-dropdown-select
                      formControlName="eyeColor"
                      id="eyeColor"
                      [options]="eyeColors"
                      [optionLabel]="'lkpValueName'"
                      [optionValue]="'lkpValueCode'"
                      placeholder="Select Eye Color"
                      [disabled]="formReadonly"
                      aria-required="true"
                      aria-describedby="eyeColorError"
                      aria-label="Select Eye Color"
                      [attr.aria-invalid]="validationErrors['eyeColor'] ? 'true' : 'false'">
                    </ppl-dropdown-select>

                    @if (validationErrors['eyeColor']) {
                    <span id="eyeColorError" class="pl-1 error-message"
                      role="alert">
                      {{ validationErrors['eyeColor'] }}
                    </span>
                    }
                  </div>

                </nz-form-control>
              </nz-form-item>
            </div>
            }
            @if(isAttrAvailable('hairColor')){
            <div nz-col [nzSm]="6" [nzXs]="24">
              <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
                <nz-form-label [nzSpan]="24" nzFor="hairColor"
                  class="ppl-form-label">{{getAttributes('hairColor').label}}
                  @if(getAttributes('hairColor').mandatory === 'Y'){
                  <span>*</span>
                  }
                </nz-form-label>
                <nz-form-control [nzSpan]="24" class="ppl-form-control"
                  nz-tooltip
                  nzTooltipTitle="{{getAttributes('hairColor').tooltip}}"
                  nzTooltipPlacement="topRight">
                  <div [ngClass]="{ 'error': validationErrors['hairColor'] }">
                    <ppl-dropdown-select
                      formControlName="hairColor"
                      id="hairColor"
                      [options]="hairColors"
                      [optionLabel]="'lkpValueName'"
                      [optionValue]="'lkpValueCode'"
                      placeholder="Select Hair Color"
                      [disabled]="formReadonly"
                      aria-required="true"
                      aria-describedby="hairColorError"
                      aria-label="Select Hair Color"
                      [attr.aria-invalid]="validationErrors['hairColor'] ? 'true' : 'false'">
                    </ppl-dropdown-select>

                    @if (validationErrors['hairColor']) {
                    <span id="hairColorError" class="pl-1 error-message"
                      role="alert">
                      {{ validationErrors['hairColor'] }}
                    </span>
                    }
                  </div>

                </nz-form-control>
              </nz-form-item>
            </div>
            }
            @if(isAttrAvailable('birthPlace')){
            <div nz-col [nzSm]="6" [nzXs]="24">
              <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
                <nz-form-label [nzSpan]="24" nzFor="birthPlace"
                  class="ppl-form-label">{{getAttributes('birthPlace').label}}
                  @if(getAttributes('birthPlace').mandatory === 'Y'){
                  <span>*</span>
                  }
                </nz-form-label>
                <nz-form-control [nzSpan]="24" class="ppl-form-control">
                  <div nz-tooltip [nzTooltipTitle]
                    nzTooltipPlacement="topRight">
                    <input nz-input formControlName="birthCity" id="birthCity"
                      placeholder="City" [readonly]="formReadonly" />
                  </div>
                </nz-form-control>
                <nz-form-control [nzSpan]="24" class="ppl-form-control"
                  style="margin: 0px 4px;">
                  <div nz-tooltip [nzTooltipTitle]
                    nzTooltipPlacement="topRight">
                    <input nz-input formControlName="birthState" id="birthState"
                      placeholder="State" [readonly]="formReadonly" />
                  </div>
                </nz-form-control>
                <nz-form-control [nzSpan]="24" class="ppl-form-control">
                  <div nz-tooltip [nzTooltipTitle]
                    nzTooltipPlacement="topRight">
                    <input nz-input formControlName="birthCountry"
                      id="birthCountry" placeholder="Country"
                      [readonly]="formReadonly" />
                  </div>
                </nz-form-control>
              </nz-form-item>
            </div>
            }
          </nz-row>
          <!-- <nz-divider class="divider"></nz-divider> -->
        </div>
        }
      </nz-row>
      }
    </form>
  </nz-card>
</div>}
@else if(mode==="read"){
<div nz-row>
  @if(isAttrAvailable('taskManager')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12" class="ppl-read-label">{{
      getAttributes('taskManager').label }} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['taskManager']}}</div>
  </div>
  }
  @if(isAttrAvailable('businessName')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12" class="ppl-read-label">{{
      getAttributes('businessName').label }} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['businessName']}}</div>
  </div>
  }
  @if(isAttrAvailable('fname')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12" class="ppl-read-label">{{
      getAttributes('fname').label }} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['fname']}}</div>
  </div>
  }
  @if(isAttrAvailable('mname')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('mname').label}} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['mname']}}</div>
  </div>
  }
  @if(isAttrAvailable('lname')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('lname').label}} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['lname']}}</div>
  </div>
  }
  @if(isAttrAvailable('maiden_name')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('maiden_name').label}} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['maiden_name']}}</div>
  </div>
  }
  @if(isAttrAvailable('dob')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('dob').label}} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['dob'] }}</div>
  </div>
  }
  @if(isAttrAvailable('gender')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('gender').label}} :</div>
    <div nz-col nzSpan="12">{{(getLookupValue(gender,
      filledInfo['gender']))}}</div>
  </div>
  }
  @if(isAttrAvailable('state')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12" class="ppl-read-label">{{
      getAttributes('state').label }} :</div>
    <div nz-col nzSpan="12">{{ (getLookupValue(states, this.state))}}</div>
  </div>
  }
  @if(isAttrAvailable('isProvidingServices')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('isProvidingServices').label}}
      :</div>
    <div nz-col nzSpan="12">{{ filledInfo['isProvidingServices'] }}</div>
  </div>
  }
  @if(isAttrAvailable('SSN')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('SSN').label}} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['SSN']}}</div>
  </div>
  }
  @if(isAttrAvailable('ITIN')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('ITIN').label}} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['ITIN']}}</div>
  </div>
  }
  @if(isAttrAvailable('CIN')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('CIN').label}} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['CIN']}}</div>
  </div>
  }
  @if(isAttrAvailable('EIN')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('EIN').label}} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['EIN']}}</div>
  </div>
  }
  @if(isAttrAvailable('waiver')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('waiver').label}} :</div>
    <div nz-col nzSpan="12">{{ getLookupValue(waiver, filledInfo['waiver'])
      }}</div>
  </div>
  }
  @if(isAttrAvailable('mcoOrgName')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('mcoOrgName').label}} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['mcoOrgName'] }}</div>
  </div>
  }
  @if(isAttrAvailable('fiOrgName')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('fiOrgName').label}} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['fiOrgName'] }}</div>
  </div>
  }
  @if(isAttrAvailable('relationToParticipant')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('relationToParticipant').label}}
      :</div>
    <div nz-col nzSpan="12">{{ filledInfo.relationToParticipant ?
      getLookupValue(relationshipOptions, filledInfo['relationToParticipant']) :
      filledInfo.relationToParticipant}}</div>
  </div>
  }
  @if(isAttrAvailable('showOnDirectory')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('showOnDirectory').label}} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['showOnDirectory']}}</div>
  </div>
  }
  @if(isAttrAvailable('NPI')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('NPI').label}} :</div>
    <div nz-col nzSpan="12">{{ filledInfo['NPI']}}</div>
  </div>
  }
  @if(isAttrAvailable('additionalDemographics')){
  <div nz-col nzSpan="12">
    <div nz-col nzSpan="12"
      class="ppl-read-label">{{getAttributes('additionalDemographics').label}}
      :</div>
    @if(isAttrAvailable('race')){
    <div nz-col nzSpan="12">
      <div nz-col nzSpan="12"
        class="ppl-read-label">{{getAttributes('race').label}} :</div>
      <div nz-col nzSpan="12">{{ filledInfo.race ? getLookupValue(raceOptions,
        filledInfo['race']) : filledInfo.race}}</div>
    </div>
    }
    @if(isAttrAvailable('height')){
    <div nz-col nzSpan="12">
      <div nz-col nzSpan="12"
        class="ppl-read-label">{{getAttributes('height').label}} :</div>
      <div nz-col nzSpan="12">{{ filledInfo['heightFeet']}} Feet {{
        filledInfo['heightInches'] || 0}} Inches</div>
    </div>
    }
    @if(isAttrAvailable('weight')){
    <div nz-col nzSpan="12">
      <div nz-col nzSpan="12"
        class="ppl-read-label">{{getAttributes('weight').label}} :</div>
      <div nz-col nzSpan="12">{{ filledInfo['weight'] }}</div>
    </div>
    }
    @if(isAttrAvailable('eyeColor')){
    <div nz-col nzSpan="12">
      <div nz-col nzSpan="12"
        class="ppl-read-label">{{getAttributes('eyeColor').label}} :</div>
      <div nz-col nzSpan="12">{{ filledInfo.eyeColor ? getLookupValue(eyeColors,
        filledInfo['eyeColor']) : filledInfo.eyeColor}}</div>
    </div>
    }
    @if(isAttrAvailable('hairColor')){
    <div nz-col nzSpan="12">
      <div nz-col nzSpan="12"
        class="ppl-read-label">{{getAttributes('hairColor').label}} :</div>
      <div nz-col nzSpan="12">{{ filledInfo.hairColor ?
        getLookupValue(hairColors, filledInfo['hairColor']) :
        filledInfo.hairColor}}</div>
    </div>
    }
    @if(isAttrAvailable('birthPlace')){
    <div nz-col nzSpan="12">
      <div nz-col nzSpan="12"
        class="ppl-read-label">{{getAttributes('birthPlace').label}} :</div>
      <div nz-col nzSpan="12">{{ filledInfo['birthCity']}} {{
        filledInfo['birthState']}} {{ filledInfo['birthCountry']}}
      </div>
    </div>
    }
  </div>
  }
</div>
}
